export const PAGES_SIMPLES = [
  {
    path: "/a-propos",
    category: "Le site",
    title: "À propos – Parieurs Sportifs",
    description: "Qui sommes-nous, notre mission, notre indépendance et notre financement.",
    h1: "À propos",
    sections: [
      {
        id: "mission",
        h2: "Notre mission",
        blocks: [
          {
            t: "p",
            html: "Donner aux novices les clés pour comprendre les paris sportifs en France : cotes, règles, cadre légal, risques.",
          },
        ],
      },
      {
        id: "independance",
        h2: "Notre indépendance",
        blocks: [
          {
            t: "p",
            html: "Parieurs Sportifs est un site d'information et de pédagogie consacré à la compréhension des paris sportifs. Il ne perçoit <strong>aucune commission d'opérateur</strong>, ne contient aucun lien d'affiliation, ne prend aucun pari, ne propose aucun service de pronostics payants et n'agit pas comme opérateur de jeux ou de paris.",
          },
        ],
      },
      {
        id: "financement",
        h2: "Notre financement",
        blocks: [
          {
            t: "p",
            html: "Le site est financé par ses éditeurs. Si cette situation évolue, elle sera indiquée clairement sur cette page.",
          },
        ],
      },
      {
        id: "engagements",
        h2: "Nos engagements",
        blocks: [
          {
            t: "p",
            html: "Exactitude des informations, mise à jour régulière, correction rapide des erreurs, aucun contenu incitatif.",
          },
        ],
      },
      {
        id: "editeur",
        h2: "L'éditeur",
        blocks: [
          {
            t: "p",
            html: "Parieurs Sportifs est édité à titre personnel par Julien MAGLIETTI, 22 rue Gustavin, 06300 Nice, France. Contact : <a href=\"mailto:hello@parieurs-sportifs.fr\" class=\"font-semibold text-[#2BB08A] underline transition-colors hover:text-[#0B1F3A]\">hello@parieurs-sportifs.fr</a>.",
          },
        ],
      },
    ],
  },
  {
    path: "/mentions-legales",
    category: "Le site",
    title: "Mentions légales – Parieurs Sportifs",
    description: "Mentions légales du site Parieurs Sportifs : éditeur, hébergeur, propriété intellectuelle, responsabilité.",
    h1: "Mentions légales",
    sections: [
      {
        id: "editeur-du-site",
        h2: "Éditeur du site",
        blocks: [
          {
            t: "p",
            html: "Parieurs Sportifs est édité à titre personnel par :<br/><br/><strong>Julien MAGLIETTI</strong><br/>22 rue Gustavin<br/>06300 Nice — France<br/>E-mail : <a href=\"mailto:hello@parieurs-sportifs.fr\" class=\"font-semibold text-[#2BB08A] underline transition-colors hover:text-[#0B1F3A]\">hello@parieurs-sportifs.fr</a><br/><br/>Directeur de la publication : Julien MAGLIETTI.",
          },
        ],
      },
      {
        id: "hebergeur",
        h2: "Hébergeur",
        blocks: [
          {
            t: "p",
            html: "IONOS SARL<br/>7, place de la Gare — BP 70109<br/>57200 Sarreguemines Cedex — France<br/>Téléphone : 0970 808 911 (appel non surtaxé)<br/>Site : <a href=\"https://www.ionos.fr\" target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"font-semibold text-[#2BB08A] underline transition-colors hover:text-[#0B1F3A]\">www.ionos.fr</a>",
          },
        ],
      },
      {
        id: "propriete-intellectuelle",
        h2: "Propriété intellectuelle",
        blocks: [
          {
            t: "p",
            html: "L'ensemble des contenus du site est protégé. Toute reproduction sans autorisation est interdite.",
          },
        ],
      },
      {
        id: "responsabilite",
        h2: "Responsabilité",
        blocks: [
          {
            t: "p",
            html: "Les informations sont fournies à titre indicatif et pédagogique. Elles ne constituent ni un conseil juridique, fiscal ou financier, ni une incitation à jouer. Les conditions des opérateurs évoluent : se référer à leurs sources officielles.",
          },
        ],
      },
      {
        id: "liens-externes",
        h2: "Liens externes",
        blocks: [
          {
            t: "p",
            html: "Le site renvoie à des sites tiers dont il n'est pas responsable du contenu.",
          },
        ],
      },
      {
        id: "prevention",
        h2: "Prévention",
        blocks: [
          {
            t: "callout",
            kind: "warn",
            html: "Jouer comporte des risques : endettement, isolement, dépendance. Pour être aidé, appelez le 09 74 75 13 13 (appel non surtaxé).",
          },
        ],
      },
    ],
  },
  {
    path: "/confidentialite",
    category: "Le site",
    title: "Politique de confidentialité – Parieurs Sportifs",
    description: "Données collectées, finalités, durées de conservation et vos droits RGPD sur Parieurs Sportifs.",
    h1: "Politique de confidentialité",
    sections: [
      {
        id: "responsable",
        h2: "Responsable du traitement",
        blocks: [{ t: "p", html: "[Éditeur — à compléter dans la configuration.]" }],
      },
      {
        id: "donnees-collectees",
        h2: "Données collectées",
        blocks: [
          {
            t: "p",
            html: "Données du formulaire de contact (nom, e-mail, message) ; données de fréquentation anonymisées.",
          },
        ],
      },
      {
        id: "finalites",
        h2: "Finalités",
        blocks: [
          {
            t: "p",
            html: "Répondre aux demandes, mesurer l'audience de façon anonyme, assurer la sécurité du site.",
          },
        ],
      },
      {
        id: "base-legale",
        h2: "Base légale",
        blocks: [
          {
            t: "p",
            html: "Consentement (formulaire), intérêt légitime (statistiques anonymisées).",
          },
        ],
      },
      {
        id: "duree",
        h2: "Durée de conservation",
        blocks: [
          { t: "p", html: "12 mois pour les messages, 13 mois pour les statistiques." },
        ],
      },
      {
        id: "destinataires",
        h2: "Destinataires",
        blocks: [
          {
            t: "p",
            html: "L'éditeur et ses prestataires techniques, sans revente ni cession à des tiers.",
          },
        ],
      },
      {
        id: "vos-droits",
        h2: "Vos droits",
        blocks: [
          {
            t: "p",
            html: "Accès, rectification, effacement, opposition, limitation, portabilité, sur demande via la page Contact.",
          },
        ],
      },
      {
        id: "reclamation",
        h2: "Réclamation",
        blocks: [
          {
            t: "p",
            html: 'Auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer nofollow" class="font-semibold text-[#2BB08A] underline transition-colors hover:text-[#0B1F3A]">cnil.fr</a>).',
          },
        ],
      },
    ],
  },
  {
    path: "/cookies",
    category: "Le site",
    title: "Politique de cookies – Parieurs Sportifs",
    description: "Cookies utilisés sur Parieurs Sportifs : uniquement des cookies nécessaires et des statistiques anonymisées, sans publicité.",
    h1: "Politique de cookies",
    sections: [
      {
        id: "cookies-necessaires",
        h2: "Cookies strictement nécessaires",
        blocks: [
          {
            t: "p",
            html: "Vérification de la majorité, mémorisation du consentement, sécurité. Ces cookies ne requièrent pas de consentement.",
          },
        ],
      },
      {
        id: "cookies-mesure",
        h2: "Cookies de mesure d'audience anonymisée",
        blocks: [
          {
            t: "p",
            html: "Activés uniquement après consentement, sauf si l'outil utilisé est exempté.",
          },
        ],
      },
      {
        id: "aucun-cookie-publicitaire",
        h2: "Aucun cookie publicitaire",
        blocks: [
          { t: "p", html: "Aucun cookie publicitaire, aucun traceur d'affiliation." },
        ],
      },
      {
        id: "gestion",
        h2: "Gestion",
        blocks: [
          {
            t: "p",
            html: "Un lien « Gérer mes cookies » dans le pied de page rouvre le panneau de choix, où l'on peut accepter ou refuser.",
          },
        ],
      },
    ],
  },
];
